import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL  = "https://paeinmibkuzdwoibdoup.supabase.co";
const SUPABASE_ANON = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBhZWlubWlia3V6ZHdvaWJkb3VwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODgyNjA3OTIsImV4cCI6MjEwMzgzNjc5Mn0.oIupnf1ZeaDGLr5OlG3FHTLHV1JJRPERFEAp_b4vXVA";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON);
